import Stack from "components/Stack";

import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import { IMemoSection } from "entities/Memo/sdk";
import { useProformaForDealManager } from "entities/Memo/utils";
import ProformaDevelopmentBudget from "entities/Proforma/components/ProformaDevelopmentBudget";

import PrintableSectionSummary from "../PrintableSectionSummary";

interface IPrintableSectionDevelopmentBudget {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
}

const PrintableSectionDevelopmentBudget = ({
  dealId,
  externalToken,
}: IPrintableSectionDevelopmentBudget) => {
  const { data: proforma } = useProformaForDealManager({
    dealId,
    token: externalToken,
  });

  return (
    <>
      {proforma ? (
        <Stack spacing={2} data-testid="development-budget-section">
          <Stack justifyContent="space-between" spacing={4}>
            <ProformaDevelopmentBudget proforma={proforma} />
            <PrintableSectionSummary
              title="Development budget description"
              category="Development Descriptions"
              dealId={dealId}
              externalToken={externalToken}
            />
          </Stack>
        </Stack>
      ) : (
        <NoProformaUploaded title="Development budget" />
      )}
    </>
  );
};

export default PrintableSectionDevelopmentBudget;
